/* eslint-disable react/destructuring-assignment */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import DateFnsUtils from '@date-io/date-fns';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import moment from 'moment';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  dateFormat,
  dateFormatForDatePicker,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import { isReadOnly as readOnly } from '../../../../SharedModules/utilities/utilities';

export default (props) => {
  const { column, rowIndex, isEnablebyRole } = props;
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  let isReadOnly = false;
  if (loginState) {
    isReadOnly =
      readOnly(window.location.pathname, loginState)?.readOnly || false;
  }
  const compareData = useSelector(
    (state) => state.sharedState.GroupReducer.compareData
  );
  const handleChangeDate = (d, event) => {
    if (d !== 'Invalid Date') {
      const { colId } = props.column;
      let value = null;
      if (event === 'onBlur' && d.target.value && d.target.value.length > 5) {
        const data = d.target.value.split('/');
        if (data[2].split('_').length === 3) {
          value = moment(d.target.value, 'MM/DD/YY').format(dateFormat);
        } else {
          value =
            d.target.value && d.target.value !== '' ? d.target.value : null;
        }
      } else {
        value = event === 'onBlur' ? d.target.value : d;
      }

      optimiseValidationCall(compareData, props?.data);
      props.node.setDataValue(colId, value);
    }
  };

  const debounce = (func) => {
    let timer;
    let _this = null;
    return function (args, args2) {
      // const context = this;
      _this = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func(args, args2);
        // func.apply(func, args);
      }, 300);
    };
  };

  const optimiseValidationCall = useCallback(debounce(props.handleBlur), []);
  return (
    <div className='fullWidth w-100  tbl-manufacturer-inner'>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        {/* <label className="m-0 hide-elm" htmlFor={`${column.colId}_${rowIndex}`}>
          <span>label</span>{' '}
        </label> */}
        <KeyboardDatePicker
          className={'frr-display-hidden-label'}
          id={`endDate_${column.colId}_${rowIndex}`}
          data-testid='end-date'
          label={'End Date'}
          inputProps={{ id: `endDate_${column.colId}_${rowIndex}` }}
          mask='__/__/____'
          InputLabelProps={{ shrink: true }}
          format={dateFormatForDatePicker}
          inputFormat={dateFormatForDatePicker}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          InputProps={{
            readOnly: false,
            autoFill: false,
          }}
          placeholder='mm/dd/yyyy'
          value={props.value || null}
          onChange={(e) => {
            handleChangeDate(e, 'onChange');
          }}
          onBlur={(e) => {
            handleChangeDate(e, 'onBlur');
          }}
          onKeyDown={async (e) => {
            if (e.keyCode == 67) {
              // copy date
              await window.navigator?.clipboard.writeText(e?.target?.value);
            }
          }}
          helperText={null}
          error={null}
          disabled={isReadOnly || !isEnablebyRole}
        />
      </MuiPickersUtilsProvider>
    </div>
  );
};
